export default {"src":"/_next/static/media/SST.aa190ed4.svg","height":18,"width":18};